const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Si el endpoint necesita un ID u otro parámetro, lo pedimos como función (bookDetails(bookId)).
const apiRoutes = {
    // Users
    saveUserApi: `${BASE_URL}/saveUser`,
    userProfileApi: `${BASE_URL}/user/profile`,
    userUpgradeApi: `${BASE_URL}/user/upgrade`,
    // Bookcases
    mostPopularShelfApi: `${BASE_URL}/popularBooks`,
    publicCatalogApi: `${BASE_URL}/popularBooks`, // Alias para claridad
    bookVisitedApi: `${BASE_URL}/visited_book`,
    // Book
    bookInfoApi: `${BASE_URL}/book_info`,
    // Chapter
    chapterApi: (hashOrBookId, chapterId = null) => {
        if (chapterId && chapterId !== 'undefined' && chapterId !== 'null') {
            return `${BASE_URL}/book/${hashOrBookId}/chapter/${chapterId}`;
        }
        return `${BASE_URL}/chapter/${hashOrBookId}`;
    },
    publicChapterApi: (hash) => `${BASE_URL}/public/chapter/${hash}`,
    chapterAudioApi: (dialectCode, hashOrBookId, chapterId = null) => {
        if (chapterId && chapterId !== 'undefined' && chapterId !== 'null') {
            return `${BASE_URL}/dialect/${dialectCode}/book/${hashOrBookId}/chapter/${chapterId}`;
        }
        return `${BASE_URL}/dialect/${dialectCode}/chapter/${hashOrBookId}`;
    },
    bookFiles: `${BASE_URL}/books_files/`,
    audioFiles: `${BASE_URL}/storage/book_files/`,
    ambientFiles: `${BASE_URL}/storage/ambient/`,
    // Lemmas
    apiUrlLemma: `${BASE_URL}/lemma/`,
    // Preferences
    apiUrlUpdatePreferences: `${BASE_URL}/updatePreferences`,
    // Chaper finished
    apiUrlChapterFinished: `${BASE_URL}/chapterFinished`,
    // BookCover
    apiUrlBookCover: (bookId) => `${BASE_URL}/books_files/${bookId}/cover.png`,
    // Reading list
    readingList: `${BASE_URL}/reading_list`,
    readingListItem: (bookId) => `${BASE_URL}/reading_list/${encodeURIComponent(bookId)}`,
    // Search books
    searchBooks: (query, options = {}) => {
        const safeQuery = typeof query === "string" ? query : "";
        const params = new URLSearchParams();
        if (options.language) params.set("lang", options.language);
        if (options.category) params.set("category", options.category);
        if (options.limit) params.set("limit", options.limit);

        const queryString = params.toString();
        const endpoint = `${BASE_URL}/search/books/${encodeURIComponent(safeQuery)}`;
        return queryString ? `${endpoint}?${queryString}` : endpoint;
    },


    /* Others: */
    ambientTracksApi: `${BASE_URL}/ambient-tracks`,
    apiFeedbackIndex: `${BASE_URL}/feedBackIndex`,
    apiFeedback: `${BASE_URL}/feedBackIndex`,
    apiFeedbackNoRegistration: `${BASE_URL}/feedBackIndexNoRegistration`,
  
};

export default apiRoutes;
